export default __webpack_public_path__ + "static/media/MaleSoccerBanner.1a0217c2.png";